import React from 'react';
import { StarIcon, CheckIcon, TrendingUpIcon, QuoteIcon, ArrowRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Marco D.',
  role: 'Liceo Classico, Bologna',
  rating: 5,
  quote: 'Insegno da 18 anni e questo è il primo strumento che mi fa davvero risparmiare tempo senza sacrificare la qualità. I miei studenti di terza liceo hanno migliorato i voti di un punto pieno in trigonometria.',
  initial: 'M',
  highlight: '+1 punto in trigonometria'
}, {
  name: 'Lucia M.',
  role: 'Scuola Media, Napoli',
  rating: 5,
  quote: 'Il soluzionario è oro puro. Non devo più risolvere tutto a mano la sera prima. La classe di terza media ora segue con un entusiasmo mai visto.',
  initial: 'L',
  highlight: 'Serate libere ritrovate'
}, {
  name: 'Paolo C.',
  role: 'Istituto Tecnico, Firenze',
  rating: 5,
  quote: 'Le slide LIM sulle funzioni sono straordinarie. La classe è coinvolta come mai prima. Recupero almeno 4 ore di preparazione a settimana — quasi mezza giornata libera.',
  initial: 'P',
  highlight: '+4 ore libere a settimana'
}, {
  name: 'Giulia R.',
  role: 'Scuola Media, Torino',
  rating: 5,
  quote: "Ero scettica all'inizio: pensavo fosse il solito PDF generico. Invece ho trovato un percorso completo, con soluzionari che funzionano davvero. Ho usato i materiali BES con due alunni DSA e hanno passato la verifica.",
  initial: 'G',
  highlight: 'Inclusione DSA & BES'
}, {
  name: 'Alessandro P.',
  role: 'Liceo Scientifico, Roma',
  rating: 5,
  quote: 'Ho finalmente recuperato le mie serate. Le slide sulle derivate hanno illuminato i miei ragazzi della quinta. Indispensabile per chi insegna alle superiori.',
  initial: 'A',
  highlight: 'Maturità più chiara'
}, {
  name: 'Sara B.',
  role: 'Docente Precaria, Bari',
  rating: 5,
  quote: 'Cambio scuola ogni anno e dover preparare tutto da zero mi distruggeva. Con Matematica Pronta arrivo in classe il primo giorno con il programma già impostato. Vale dieci volte il prezzo.',
  initial: 'S',
  highlight: 'Pronto al volo'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-368">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-369"></div>
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(245,158,11,0.05) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-370"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-371">
        <div className="text-center mb-10 sm:mb-14" data-id="element-372">
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-cta-green uppercase tracking-[0.2em] mb-3 sm:mb-4 bg-cta-green/10 border border-cta-green/20 px-4 py-1.5 rounded-full" data-id="element-373">
            <CheckIcon className="w-4 h-4" strokeWidth={2.8} data-id="element-374" />
            Recensioni verificate
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-tight" data-id="element-375">
            Cosa dicono i docenti
            <br className="hidden sm:block" data-id="element-376" />
            <span className="text-text-main" data-id="element-377"> che lo usano </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cta-green to-emerald-300" data-id="element-378">
              ogni giorno
            </span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-379">
            Oltre{' '}
            <span className="text-text-main font-bold" data-id="element-380">
              800 docenti italiani
            </span>{' '}
            hanno già scelto Matematica Pronta. Ecco cosa raccontano.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-381">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col gap-4 hover:border-cta-green/40 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(16,185,129,0.15)] transition-all duration-300 relative overflow-hidden group" data-id="element-382">
              <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-cta-green to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-383"></div>

              <QuoteIcon className="absolute top-5 right-5 w-10 h-10 text-cta-green/10 pointer-events-none" strokeWidth={2} aria-hidden="true" data-id="element-384" />

              <div className="flex items-center justify-between gap-2 relative z-10" data-id="element-385">
                <div className="flex gap-0.5" aria-label={`${t.rating} stelle su 5`} data-id="element-386">
                  {Array.from({
                length: t.rating
              }).map((_, idx) => <StarIcon key={idx} className="w-4 h-4 text-secondary fill-secondary" data-id="element-387" />)}
                </div>
                <span className="text-cta-green text-[10px] font-black uppercase tracking-wider flex items-center gap-1 bg-cta-green/10 border border-cta-green/20 px-2 py-0.5 rounded-full" data-id="element-388">
                  <CheckIcon className="w-3 h-3" strokeWidth={3} data-id="element-389" />
                  Verificato
                </span>
              </div>

              <p className="text-text-main text-sm sm:text-base leading-relaxed font-medium flex-1 relative z-10" data-id="element-390">
                "{t.quote}"
              </p>

              <div className="inline-flex items-center gap-2 self-start bg-cta-green/10 text-cta-green border border-cta-green/25 text-xs font-black px-3 py-1.5 rounded-full" data-id="element-391">
                <TrendingUpIcon className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-392" />
                {t.highlight}
              </div>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-393">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-cta-green to-emerald-700 flex items-center justify-center text-white font-black text-base flex-shrink-0 shadow-[0_0_15px_rgba(16,185,129,0.25)]" data-id="element-394">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-395">
                  <p className="text-text-main font-black text-sm leading-tight" data-id="element-396">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs leading-tight mt-0.5" data-id="element-397">
                    {t.role}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-10 sm:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 bg-bg-alt border border-border-light rounded-2xl py-5 px-6 sm:py-6 sm:px-8" data-id="element-398">
          <div className="flex items-center gap-3" data-id="element-399">
            <div className="flex -space-x-3" data-id="element-400">
              {['M', 'G', 'P', 'S', 'L'].map((c, i) => <div key={i} className="w-9 h-9 rounded-full bg-gradient-to-br from-cta-green to-emerald-700 border-2 border-bg-alt flex items-center justify-center text-white font-black text-xs" data-id="element-401">
                  {c}
                </div>)}
            </div>
            <div className="text-left" data-id="element-402">
              <p className="text-text-main font-black text-base sm:text-lg leading-tight" data-id="element-403">
                +800 docenti
              </p>
              <p className="text-text-sec text-xs" data-id="element-404">hanno già scelto il Kit</p>
            </div>
          </div>

          <div className="hidden sm:block w-px h-10 bg-border-light" data-id="element-405"></div>

          <div className="flex items-center gap-2" data-id="element-406">
            <div className="flex gap-0.5" aria-label="4.9 stelle su 5" data-id="element-407">
              {Array.from({
              length: 5
            }).map((_, idx) => <StarIcon key={idx} className="w-4 h-4 text-secondary fill-secondary" data-id="element-408" />)}
            </div>
            <div className="text-left" data-id="element-409">
              <p className="text-text-main font-black text-base leading-tight" data-id="element-410">
                4.9 / 5
              </p>
              <p className="text-text-sec text-xs" data-id="element-411">media recensioni</p>
            </div>
          </div>

          <div className="hidden sm:block w-px h-10 bg-border-light" data-id="element-412"></div>

          <a href="#pricing" className="btn-cta text-sm sm:text-base px-5 py-3 whitespace-nowrap inline-flex items-center gap-2" data-id="element-413">
            <span className="relative z-10 inline-flex items-center gap-2" data-id="element-414">
              🚀 Voglio il Kit
              <ArrowRightIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-415" />
            </span>
          </a>
        </div>
      </div>
    </section>;
}